
import React from 'react';

import { useSelector } from 'react-redux';

import {
  Button,
  FormTextField,
  FormikWrapper,
} from '@uncinc/uncinc-react-kitchen-sink';

import {
  CoreLink,
  UI_OPERATION_STATUS_ERROR,
  UI_OPERATION_STATUS_REQUEST,
  UI_OPERATION_STATUS_REASON_BLOCKED,
  UI_OPERATION_STATUS_REASON_UNRECOGNIZED,
  UI_OPERATION_STATUS_REASON_FLOOD,
} from '@uncinc/react-drupal-core';

import { useTranslation } from 'react-i18next';

import './style.scss';

const CheckoutLogin = ({ onLogin }) => {
  const { t } = useTranslation();

  const userLoginStatus = useSelector((state) => state.getIn(['ui', 'user', 'operations', 'login', 'status']));
  const userLoginReason = useSelector((state) => state.getIn(['ui', 'user', 'operations', 'login', 'reason']));
  const isLoading = (userLoginStatus === UI_OPERATION_STATUS_REQUEST);

  let reason;
  switch (userLoginReason) {
    case UI_OPERATION_STATUS_REASON_BLOCKED:
      reason = t('login.blocked');
      break;
    case UI_OPERATION_STATUS_REASON_FLOOD:
      reason = t('login.flood');
      break;
    case UI_OPERATION_STATUS_REASON_UNRECOGNIZED:
      reason = t('login.unrecognized');
      break;
    default:
      reason = t('login.unknown');
  }

  const onSubmit = (values, form) => {
    onLogin(values.username, values.password);
    form.setSubmitting(false);
  };

  return (
    <div className="CheckoutLogin col-12 col-md-5">

      <h3>{t('form.login.title')}</h3>
      <p>{t('form.login.intro')}</p>

      {userLoginStatus === UI_OPERATION_STATUS_ERROR && (
        <div className="Form__error">
          {reason}
          {userLoginReason === UI_OPERATION_STATUS_REASON_BLOCKED && (
            <CoreLink className="Form__error__customer_service" href="/klantenservice">
              {t('general.customer_service')}
            </CoreLink>
          )}
        </div>
      )}

      <FormikWrapper onSubmit={onSubmit}>
        <FormTextField
          title={t('form.login.fields.email')}
          fieldName="username"
          required
        />
        <FormTextField
          title={t('form.login.fields.password')}
          fieldName="password"
          type="password"
          required
        />
        <Button
          type="submit"
          className={`Button Button--primary ${isLoading ? 'Button--loading' : ''}`}
        >
          {t('form.login.submit')}
        </Button>
        <CoreLink className="CheckoutLogin__forgot_password_link" title={t('form.login.password_forgotten')} to="/wachtwoord-vergeten" />

      </FormikWrapper>

    </div>
  );
};

export default CheckoutLogin;
